import saveAs from "file-saver";
import { useCallback } from "react";

export const useDownloadFile = (
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const download = useCallback(
    (service: any, request: any, fileName: any): void => {
      service
        .download(request)
        .then((res: any) => {
          const blob = new Blob([res], {
            type: "application/octet-stream",
          });
          saveAs(blob, fileName);
          setIsLoading && setIsLoading(false);
        })
        .catch(() => setIsLoading && setIsLoading(false));
    },
    [setIsLoading],
  );

  return { download };
};
